import { STALL_POSSESSION_CHECKLIST_DETAILS, INSERT_UPDATE_STALL_POSSESSION_CHECKLIST } from "../../../utils/constants";


const initialState = [];

function stallPossessionChecklistListReducer(state = initialState, action) {
    const { type, payload } = action

    switch (type) {
        case STALL_POSSESSION_CHECKLIST_DETAILS:
            return [...state, payload];
        case INSERT_UPDATE_STALL_POSSESSION_CHECKLIST:
            return [...state, payload];
        default:
            return state;
    }
};

export default stallPossessionChecklistListReducer